<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <div class="text-h5">
          It seems
        </div>
        <div class="text-h6 text-md-h5">
          You don't have an active subscription...
        </div>
        <div class="text-h3 text-md-h4 font-weight-bold">
          We have something for you!
        </div>
        <div class="mt-4 plan">
          <v-img
            max-height="200"
            contain
            position="center center"
            alt="Visionbook"
            src="@/assets/plan/plan_1.png"
          />
        </div>
        <div class="mt-4 text-h5 font-weight-bold">
          Early Access Plan - 85% OFF
        </div>
        <div class="text-h6 font-weight-bold">
          $1.5 per month
          <span class="font-weight-regular">(billed per 6 months at $9)</span>
        </div>
        <div class="mt-4">
          <BaseButton large @click="subscription">
            Request Early Access
          </BaseButton>
        </div>
        <div class="mt-6 d-flex justify-space-between">
          <BaseButton
            :loading="loadingPortal"
            outlined
            color="gray"
            @click="billing"
          >
            {{ $t("payment.customer_portal") }}
          </BaseButton>
          <BaseButton outlined color="gray" @click="$emit('onLogout')">
            {{ $t("user.logout") }}
          </BaseButton>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/**
 * Legacy Stripe upsell modal. Not shown in normal flow (users/init no longer dispatches upgradeCustomer).
 * Kept in App.vue for minimal diff; safe to remove with related App.vue / store action wiring.
 */
import { billingPortal } from "@/helpers/paymentHelpers";

export default {
  name: "UpgradeModal",
  data: () => ({
    loadingPortal: false,
    subscriptionsUrl: process.env.VUE_APP_VB_SUBSCRIPTIONS
  }),
  methods: {
    async billing() {
      this.loadingPortal = true;
      await billingPortal();
    },
    subscription() {
      window.location.assign("/payment?interval=month&interval_count=6&tp=ea");
    }
  }
};
</script>

<style lang="scss" scoped>
.plan {
  min-height: 200px;
  margin: auto;
  border-radius: 20px;
}

@media (min-width: 960px) {
  .plan {
    width: 400px;
  }
}
</style>
